import { Service } from "./service.model";

export interface BudgetInterface {
    services: Service[];
    subtotal: number;
}